<template>
	<div>
        <b-tabs v-model="tab_index">
            <b-tab title='Ficher csv/xlsx'>
                <br />
                <edit_tabulator
                    @update="import_file(false)"
                    ref="start_tabulator"
                    :hidden="true"
                ></edit_tabulator>
                <edit_tabulator_conditions
                    ref="start_tabulator_conditions"
                    :data="start_data"
                    @update="import_file_conditions"></edit_tabulator_conditions>
            </b-tab>
            <b-tab title="Saisie manuelle">
                <br />
                <b-textarea v-model="data_textarea" :rows="10"></b-textarea>
            </b-tab>
        </b-tabs>
	</div>
</template>

<script>
	var XLSX = require("xlsx");
	var clone = require("clone");
	
    import * as json2csv from "json2csv";
    import uniqueId from "lodash.uniqueid";

	import edit_tabulator_conditions from "../components/edit_tabulator_conditions.vue";
	import edit_tabulator from "../components/edit_tabulator.vue";


	export default {
		name: "data_component",
		components: {
            edit_tabulator_conditions,
            edit_tabulator,
		},
        props: {
            column_data: {
                default: "data"
            }
        },
		data() {
			return {
                type_data_start: "tabulator",
                tab_index: 0,
                start_data: [],
                data_textarea: "",
                columns: []
			};
		},
        watch: {
            type_data_start() {
                var self = this;
                this.$nextTick(() => {
                    self.$emit("set_data_in", self.workflow);
                });
            },
            async tab_index() {
                var type_data = "";

                if (this.tab_index == 0)
                {
                    type_data = "tabulator";
                    var data = await this.$refs.start_tabulator_conditions.get_data();
                    if (data.length > 0)
                    {
                        this.columns = Object.keys(data[0])
                    }
                }
                else
                {
                    type_data = "textarea";
                    this.columns = [this.column_data];
                }

                this.$emit("type_data", type_data);
            },
            columns: {
				deep: true,
				handler: function (newVal, oldVal) {
                    this.$emit("columns", this.columns);
                }
            }
        },
		methods: {
			import_file(add, data = null)
			{
                data = this.$refs.start_tabulator.get_data();
                this.start_data = data;
			},
			async import_file_conditions(add, data = null)
			{               
                var data = await this.$refs.start_tabulator_conditions.get_data();
                if (data.length > 0)
                {
                    this.columns = Object.keys(data[0])
                }
			},
            async save()
            {   
                if (this.tab_index == 0)
                    return await this.$refs.start_tabulator_conditions.get_data_blob();
                else
                {
                    var data = this.data_textarea.split("\n");
                    for (var i = 0; i < data.length; i++)
                    {
                        var line = {};
                        line[this.column_data] = data[i];
                        data[i] = line;
                    }
                    var str_csv = json2csv.parse(data, {
                        fields: Object.keys(data.length > 0 ? data[0] : {}),
                        fieldNames: Object.keys(data.length > 0 ? data[0] : {}),
                    });

                    return new Blob([str_csv], {
                        type: "text/plain",
                    });
                }
            }
		},
		mounted: async function () {
		},
	};
</script>
